import React from 'react';
import { FaAward } from 'react-icons/fa';
import { VscFolderLibrary } from 'react-icons/vsc';
import ME from '../../assets/Header.png';
import './about.css'
const About = () => {
  return (
    <section id="about">
      <h5>Get to know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="me" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>CSE</h5>
              <small>4th Year</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>20+ Completed Projects</small>
            </article>
          </div>
          <p>Hello, I'm Vishal Kumar, currently a fourth-year student with a keen interest in problem-solving and algorithms, and a strong focus on developing web applications. I possess proficient communication skills and have a deep passion for continuous learning.</p>
          <a href="#contact" className="btn btn-primary">Let's Contact</a>
        </div>
      </div>
    </section>
  )
}

export default About